import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntityPropertySignalTypeIconComponent } from './components/entity-property-signal-type-icon/entity-property-signal-type-icon.component';
import { EntityPropertyComponent } from './components/entity-property/entity-property.component';
import { EntityPropertyValueHostDirective } from './directives/entity-property-value-host/entity-property-value-host.directive';
import { EntityPropertyDateComponent } from './components/entity-property-date/entity-property-date.component';
import { MatIconModule } from '@angular/material/icon';
import { EntityPropertyDescriptionComponent } from './components/entity-property-description/entity-property-description.component';

@NgModule({
  declarations: [
    EntityPropertyComponent,
    EntityPropertySignalTypeIconComponent,
    EntityPropertyValueHostDirective,
    EntityPropertyDateComponent,
    EntityPropertyDescriptionComponent
  ],
  imports: [CommonModule, MatIconModule],
  exports: [EntityPropertyComponent]
})
export class EntityListModule {}
